import { Pipe, PipeTransform } from '@angular/core';

/** @deprecated - this is moved to libs */
@Pipe({
    name: 'kilometer'
})
export class KilometerPipe implements PipeTransform {
    transform(value: any): any {
        const number = Number(value);
        const km = number / 1000;

        return Math.round(km);
    }
}
